export const getIdFromRelation = (item, relation) => {
  if (!item) {
    return -1;
  }
  if (!item.relationships) {
    return -1;
  }
  if (!item.relationships[relation]) {
    return -1;
  }
  if (!item.relationships[relation].data) {
    return -1;
  }
  if (!item.relationships[relation].data.length > 0) {
    return -1;
  }
  if (!item.relationships[relation].data[0]) {
    return -1;
  }
  if (!item.relationships[relation].data[0].id) {
    return -1;
  }
  return item.relationships[relation].data[0].id;
};



/** WEBPACK FOOTER **
 ** ./src/modules/app/selectors.js
 **/